import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'gendered',
})
@Injectable({
  providedIn: 'root',
})
export class GenderedPipe implements PipeTransform {
  transform(value: string, salutation: string, name: string, language: string): string {
    if (!value) return '';
    return language === 'de'
      ? this.transformDe(value, salutation, name)
      : this.transformEnglish(value, salutation, name);
  }

  transformDe(value: string, salutation: string, name: string): string {
    const female = salutation === 'Frau';
    return value
      .replace(/\(Name\)/g, salutation + ' ' + name)
      .replace(/\(name\)/g, salutation + ' ' + name)
      .replace(/\(Namen\)/g, (female ? salutation : salutation + 'n') + ' ' + name)
      .replace(/\(namen\)/g, (female ? salutation : salutation + 'n') + ' ' + name)
      .replace(/\(([^/()]+)\/([^/()]+)\)/g, (_, m, f) => (female ? f : m));
  }

  transformEnglish(value: string, salutation: string, name: string): string {
    const female = salutation === 'Frau';
    return value
      .replace(/\(Name\)/g, female ? 'Ms. ' + name : 'Mr. ' + name)
      .replace(/\(name\)/g, female ? 'Ms. ' + name : 'Mr. ' + name)
      .replace(/\(([^/()]+)\/([^/()]+)\)/g, (_, m, f) => (female ? f : m));
  }
}

@Pipe({ name: 'salutation' })
export class SalutationPipe {
  transform(gender: string, language: 'de' | 'en'): string {
    const female = gender === 'Frau';
    if (language === 'en') {
      return female ? 'Ms.' : 'Mr.';
    }
    return gender;
  }
}
